import { createAsyncThunk } from "@reduxjs/toolkit"

import { StatusCodeResponse } from "./../../../../network/constants"
import { GetAuctionParams } from "../../../../network/event/event1m/type"
import homeAuctionServices from "../../../../network/event/event1m/services"
import { hideLoading, showLoading } from "../../../common/loading/store/slice"

export const getDiscover = createAsyncThunk(
  "event/DISCOVER",
  async (params: GetAuctionParams, { rejectWithValue, dispatch }) => {
    dispatch(showLoading())
    const res = await homeAuctionServices.getAuction(params)
    dispatch(hideLoading())
    try {
      if (res.status === StatusCodeResponse.SUCCESS) {
        return res.data
      } else {
        return rejectWithValue(res.status)
      }
    } catch (error) {
      return rejectWithValue(StatusCodeResponse.SYSTEM_ERROR)
    }
  }
)
